var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"center-loader"},[_c('loadingSection')],1):_c('div',{staticClass:"container-activated"},[(_vm.checked)?_c('div',[_vm._v(" ¡Tu cuenta ha sido activada con éxito! Pincha "),_c('a',{attrs:{"href":_vm.$router.resolve({
          name: 'LoginPage',
        }).href}},[_vm._v("aquí")]),_vm._v(" para iniciar sesión en tu empresa. ")]):_c('div',[_vm._v(" "+_vm._s(_vm.bad_message)+" "),_c('a',{attrs:{"href":_vm.$router.resolve({
          name: 'LoginPage',
        }).href}},[_vm._v("regresar al login")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }